import { Component, OnInit, Input } from "@angular/core";
import { ActivationEnd, Router, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { NavigationEnd } from "@angular/router";

@Component({
  selector: "app-a210-steps",
  templateUrl: "./a210-steps.component.html",
  styleUrls: ["./a210-steps.component.scss", "../../platform.component.scss"],
})
export class A210StepsComponent implements OnInit {
  @Input() department_type: string;

  currentActive: number = 1;
  currentUrl: string;
  totalSteps = 4;
  progressWidth: string = "0%";

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.handleProgress();
  }

  public handleProgress(): void {
    if (this.currentUrl.startsWith("/pages/platform/a210")) {
      this.currentActive = 1;
    } else if (this.currentUrl.startsWith("/pages/platform/a211")) {
      this.currentActive = 2;
    } else if (this.currentUrl.startsWith("/pages/platform/a212")) {
      this.currentActive = 3;
    } else if (this.currentUrl.startsWith("/pages/platform/a213")) {
      this.currentActive = 4;
    }

    this.progressWidth = this.getProgressWidth().toFixed(2) + "%";
  }

  getProgressWidth() {
    return ((this.currentActive - 1) / 3) * 100;
  }

  isActiveStep(step: number) {
    return this.currentActive >= step;
  }

  isActiveText(index: number) {
    if (index === this.currentActive) {
      return true;
    }
    return false;
  }

  ngAfterViewInit() {
  }
}
